import { useEffect } from 'react';

export default function OverflowText({ data, dependencies, id, height, twHeight, heading, text }) {
	useEffect(() => {
		if (!data) return;
		data
			.map((x) => x.EntryId)
			.forEach((id) => {
				const element = document.querySelector(`#desc_${id}`);
				if (!element || element.clientHeight <= height) return;
				document
					.querySelectorAll(`.overlay_${id}`)
					.forEach((target) => target.classList.remove('!tw-hidden'));
			});
	}, [data, height, ...dependencies]);

	if (!data || !text) return;

	return (
		<div>
			{heading && <p className='tw-font-bold tw-text-sm'>{heading}</p>}
			<div className={`tw-relative tw-overflow-hidden tw-transition-all ${twHeight}`}>
				<p id={`desc_${id}`} className='tw-text-sm'>
					{text}
				</p>
				<i
					className={`overlay_${id} !tw-hidden fa fa-angle-up tw-py-1 tw-px-1.5 tw-rounded tw-rotate-180 tw-transition-all tw-absolute tw-bottom-0 tw-right-0 tw-bg-white/80 tw-text-gray-500 tw-select-none tw-cursor-pointer tw-z-10 hover:tw-bg-slate-200/80`}
					aria-hidden='true'
					onClick={({ target }) => {
						target.parentNode.classList.toggle(twHeight);
						target.parentNode.classList.toggle('tw-max-h-full');
						target.classList.toggle('tw-rotate-180');
						target.nextSibling.classList.toggle('tw-hidden');
					}}></i>
				<div
					className={`overlay_${id} !tw-hidden tw-absolute tw-top-0 tw-w-full tw-h-full tw-bg-gradient-to-b tw-to-white tw-from-transparent tw-pointer-events-none`}></div>
			</div>
		</div>
	);
}
